import { createContext } from 'react';

// Create a context to share session configuration and user state
export const SessionContext = createContext({
  config: null,
  user: null,
  loginRoute: '/bbweb/login',
  setUser: (userData) => {},
  setConfig: (configData) => {},
});
